import React, { useEffect, useState } from 'react';

function TopicSelection({ onTopicSelect }) {
  // This function will be called with the selected topic when the user selects a topic
  const [topics, setTopics] = useState([
	'Climate change',
	'Biodiversity',
	'Extreme weather',
	'Diversity, Equity and Inclusion',
	'Cyberbullying',
	'Anxiety',
	'Nutrition',
	'Homelessness/unhoused persons',
	'AI ',
	'Braces',
	'Sports',
	'Sports betting',
	'Quick loans',
	'Recording artists',
	'Video games',
	'Drugs/substance abuse',
	'Movies',
	'Music/pop stars',
	'Side hustles/starting a business',
	'Money management/personal finance',
	'Employment ',
	'Health care',
	'Elections',
	'Social media Influencers',
	'Travel',
	'Brands',
	'The Metaverse',
	'Billionaires',
	'Clean energy',
	'Privacy',
	'World population',
	'Life span /mortality rates',
	'Junk food',
	'Working out',
	'Extinction',
	'Auto insurance for new drivers',
	'Home and property insurance',
	'Dental benefits – who pays?',
	'Doctor visit – who pays?',
	'Immigration',
	'Pandemics',
	'High obesity rates in society',
	'The housing market',
	'Mortgages',
	'Flooding, wildfires, and other natural catastrophes',
	'Space travel/exploration',
	'Interest rates',
	'Gender identity',
	'Electric cars',
	'Autonomous vehicles',
	'Supply chains',
	'Recycling'
  ]);
  const [title, setTitle] = useState('Step 1 of 2');
  const [subtitle, setSubtitle] = useState('No matter what you are interested in, there are likely risks associated with it. Chat with AI to explore these risks and how they relate to the problem solving actuaries do with math.');
  const [footerLegal, setFooterLegal] = useState('The CIA does not guarantee the completeness, reliability, or accuracy of ChatGPT\'s information.');
  const [lang, setLang] = useState('en');
  const [selectedTopic, setSelectedTopic] = useState(null);
  let shuffledTopics = topics.sort(() => Math.random() - 0.5);
  const [shownTopics, setShownTopics] = useState(shuffledTopics.slice(0, 6));

  useEffect(() => {
	if(window.lang === 'fr'){
		setLang('fr');
		setTitle('Étape 1 de 2');
		setSubtitle('Quel que soit le domaine qui vous intéresse, il est probable que des risques y soient associés. Discutez avec l’IA pour explorer ces risques et leur lien avec la résolution de problèmes que les actuaires effectuent à l’aide des mathématiques.');
		setFooterLegal('L\'ICA ne garantit pas l\'exhaustivité, la fiabilité ou l\'exactitude des informations fournies par ChatGPT.');
		const fr_topics = [
			'Changements climatiques',
			'Biodiversité',
			'Conditions météorologiques extrêmes',
			'Diversité, équité et inclusion',
			'Cyberintimidation',
			'Anxiété',
			'Nutrition',
			'Itinérance/personnes sans domicile fixe',
			'IA ',
			'Appareils orthopédiques',
			'Sports',
			'Paris sportifs',
			'Prêts rapides',
			'Artistes du disque',
			'Jeux vidéo',
			'Drogues/abus de substances',
			'Univers du film',
			'Musique/vedettes de la pop',
			'Activités annexes/création d’entreprise',
			'Gestion financière/finances personnelles',
			'Emploi ',
			'Soins de santé',
			'Élections',
			'Influenceurs dans les médias sociaux ',
			'Voyages',
			'Image de marque',
			'Métavers',
			'Milliardaires',
			'Énergie propre',
			'Vie privée',
			'Population mondiale',
			'Durée de vie/taux de mortalité',
			'Malbouffe',
			'Entraînement sportif',
			'Extinction',
			'Assurance auto pour les nouveaux conducteurs',
			'Assurance habitation et biens immobiliers',
			'Soins dentaires – qui paie?',
			'Visite chez le médecin – qui paie?',
			'Enjeux d\'immigration',
			'Pandémies',
			'Taux d’obésité élevé dans la société',
			'Marché de l’habitation',
			'Prêts hypothécaires',
			'Inondations, feux de forêt et autres catastrophes naturelles',
			'Voyages spatiaux/exploration',
			'Taux d’intérêt',
			'Identité sexuelle',
			'Voitures électriques',
			'Véhicules autonomes',
			'Chaînes d’approvisionnement',
			'Recyclage'
		];
		setTopics(fr_topics);
		let shuffledTopics = fr_topics.sort(() => Math.random() - 0.5);
		setShownTopics(shuffledTopics.slice(0, 6));
	}
  },[]);
  const shuffleTopics = () => {
	const shuffledTopics = topics.sort(() => Math.random() - 0.5);
	setShownTopics(shuffledTopics.slice(0, 6));
  }
  
  return (
    <div className="appMiddleContainer">
      <h3 className="px-xl-5 mb-2">{title}</h3>
	  {/* <p>{subtitle}</p> */}
	  <h4 className='mb-4 mb-lg-5'>{lang == 'fr' ? "D'abord, choisis un thème : " : "Start by choosing a topic:"}:</h4>
	  <div className="d-flex gap-2 mb-2 align-items-center justify-content-center flex-wrap">		
		{shownTopics.map((topic, key) => (
			<button className={`btn btn-topics btn-topic-${key} ${selectedTopic === topic ? 'active' : ''}`} key={topic} onClick={() => setSelectedTopic(topic)}>	{topic}						
			</button>		
		)).slice(0, 3)}
	  </div>
	  <div className="d-flex gap-2  align-items-center justify-content-center flex-wrap">
		{shownTopics.map((topic, key) => (
			<button className={`btn btn-topics btn-topic-${key} ${selectedTopic === topic ? 'active' : ''}`} key={topic} onClick={() => setSelectedTopic(topic)}>			
			{topic}
			</button>
		)).slice(3, 6)}
	  </div>
	  <div className="d-flex justify-content-center mt-4 mt-lg-5">
		<button className="btn btn-green" onClick={() => onTopicSelect(selectedTopic)} disabled={!selectedTopic}>{lang == 'fr' ? "Passe à l'étape 2" : "Go to step 2"}</button>
	  </div>
	  <div className="d-flex justify-content-center mt-lg-4">
		<button className="btn btn-link other-topics" onClick={() => shuffleTopics()} >{lang == 'fr' ? "Afficher d'autres thèmes" : "Show me other topics"}</button>
	  </div>
	  <div className="mt-3">
		<p class="xs">{footerLegal}</p>
	  </div>
    </div>
  );
}

export default TopicSelection;
